import React, { Component } from 'react';
import $ from 'jquery';
import 'jquery-ui-bundle';
//import 'jquery-ui-touch-punch';
import {
  LlegendaContainer,
  LlegendaWrapper,
  LlegendaBtnWrapper,
  LlegendaBtnIcon,
  LlegendaBtnIconWrapper,
  LlegendaMenuWrapper,
  CapesLlegendaWrapper,
  LlegendaBtnNotification
} from './LlegendaElement';
import { CapaLlegenda } from './CapaLlegenda/CapaLlegenda';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { displayComponents } from '../Utils/VisorsUtils';
import { LlegendaFooter } from './LlegendaFooter/LlegendaFooter';
import { LlegendaButtonIcon } from './LlegendaIcons';
export default class Llegenda extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandAll: false
    };
  }

  // Hacer la leyenda ordenable
  componentDidMount() {
    let idxSrt = '';
    $('#CapesLlegendaWrapper').sortable({
      delay: 100,
      // si se quiere hacer draggable solo la parte que se ve estando contraida, añadir a la string #notSortable2
      cancel: '#notSortable, #notSortable2',
      cursor: 'grabbing',
      // al empezar a mover guardamos el indice original de la capa
      start: function (e, ui) {
        idxSrt = ui.item.index();
      },
      // si la posición ha cambiado, ejecutamos la función onDragUpdate pasando el indice inicial y el final
      update: (e, ui) => {
        this.onDragUpdate(idxSrt, ui.item.index());
      }
    });
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (window.innerWidth < 768 && this.props.alturaInfoPunt > window.innerHeight / 2 && this.props.llegendaOpen === true) {
      this.props.changeLlegendaOpen(false);
    }
  };

  /**
   * @desc funcion que actualiza el array de capas y modifica el orden de representación en el mapa.
   */
  onDragUpdate = (idxSrt, idxEnd) => {
    // Guardamos temporalmente el elemento que hemos movido.
    let temp = this.props.arrayLayers[idxSrt];

    // Eliminamos el elemento del array.
    this.props.arrayLayers.splice(idxSrt, 1);

    // Volvemos a añadir el elemento en el índice final del drag and drop.
    this.props.arrayLayers.splice(idxEnd, 0, temp);

    // Borramos todas las representaciones de las layers en el mapa.
    this.props.arrayLayers.forEach((capa, i) => {
      this.props.map.removeLayer(capa.getOLLayer());
    });

    // Pintamos de nuevo todas las layers del array con el nuevo orden revirtiendo el array para que pinte primero las últimas y las siguientes encima.
    this.props.arrayLayers.reverse().forEach((capa, i) => {
      this.props.map.addLayer(capa.getOLLayer());
    });
    // Revertimos el array de nuevo para recuperar el orden original.
    this.props.arrayLayers.reverse();

    this.props.arrayLayers[idxEnd].setDragging(false);

    // Cancelamos el último movimiento
    $('#CapesLlegendaWrapper').sortable('cancel');
    this.forceUpdate();
  };

  onStyleChangeOrder = () => {
    this.props.arrayLayers.forEach((capa, i) => {
      this.props.map.removeLayer(capa.getOLLayer());
    });
    this.props.arrayLayers.reverse().forEach((capa, i) => {
      this.props.map.addLayer(capa.getOLLayer());
    });
    this.props.arrayLayers.reverse();
  };

  /**
   * @desc funcion para abrir la leyenda
   */
  handleOpenLlegenda = () => {
    if (this.props.arrayLayers.length === 0 && this.props.llegendaOpen === true) this.props.changeLlegendaOpen(false);
  };

  /**
   * @desc función que cambia el estado abierto / cerrado de la leyenda
   */
  onClickLlegendaBtn = () => {
    if (!this.props.isEditing) {
      if (this.props.arrayLayers.length > 0) this.props.changeLlegendaOpen(!this.props.llegendaOpen);
      if (window.innerWidth < 464 && this.props.infoPuntObert) {
        this.props.toggleMapSelector(false);
      }
    }
  };

  /**
   * @desc funcion para expandir todas las capas de la leyenda
   */
  expandAll = () => {
    this.setState({ expandAll: null }, () => this.setState({ expandAll: 'panel2' }));
  };

  /**
   * @desc funcion para contraer todas las capas de la leyenda
   */
  shrinkAll = () => {
    this.setState({ expandAll: null }, () => this.setState({ expandAll: false }));
  };

  render = () => {
    return (
      <>
        {this.handleOpenLlegenda()}
        <LlegendaContainer displayNav={displayComponents.navbar} id="Llegenda-container">
          <LlegendaWrapper id="Llegenda-wrapper">
            <LlegendaBtnWrapper selected={this.props.arrayLayers.length > 0} id="Llegenda-btn-wrapper">
              <LlegendaBtnIcon
                editing={this.props.isEditing}
                title={getTranslatedKey('obrirLlegenda')}
                id="Llegenda-btn"
                isOpen={this.props.llegendaOpen}
                selected={this.props.arrayLayers.length > 0}
                onClick={() => this.onClickLlegendaBtn()}
                aria-label={getTranslatedKey('aria_llegendaBtn')}>
                {this.props.arrayLayers && this.props.arrayLayers.length > 0 && (
                  <LlegendaBtnNotification title={this.props.arrayLayers.length + ' capes'} fontSizeEnabled={this.props.fontSizeEnabled}>
                    {this.props.arrayLayers.length < 100 ? this.props.arrayLayers.length : '+99'}
                  </LlegendaBtnNotification>
                )}
                <LlegendaBtnIconWrapper isOpen={this.props.llegendaOpen}>
                  <LlegendaButtonIcon />
                </LlegendaBtnIconWrapper>
              </LlegendaBtnIcon>
            </LlegendaBtnWrapper>
            <LlegendaMenuWrapper
              displayNav={displayComponents.navbar}
              open={this.props.llegendaOpen}
              alturaInfoPunt={this.props.alturaInfoPunt}
              infoPuntObert={this.props.infoPuntObert}>
              <CapesLlegendaWrapper id="CapesLlegendaWrapper">
                {this.props.arrayLayers.map((layer, index) => {
                  return (
                    <CapaLlegenda
                      taulaApiConditions={this.props.taulaApiConditions}
                      taulaFc={this.props.taulaFc}
                      taulaGeom={this.props.taulaGeom}
                      taulaTotal={this.props.taulaTotal}
                      taulaPage={this.props.taulaPage}
                      setTaulaGeom={this.props.setTaulaGeom}
                      updateLlegenda={this.props.updateLlegenda}
                      user={this.props.user}
                      getExternTable={this.props.getExternTable}
                      editVector={this.props.editVector}
                      setEditing={this.props.setEditing}
                      statsLayer={this.props.statsLayer}
                      showAlert={this.props.showAlert}
                      statsLayerSelect={this.props.statsLayerSelect}
                      scrollToFiltre={this.props.scrollToFiltre}
                      closeTable={this.props.closeTable}
                      setTaulaSpacialBbox={this.props.setTaulaSpacialBbox}
                      taulaSpacialBbox={this.props.taulaSpacialBbox}
                      taulaFullFilter={this.props.taulaFullFilter}
                      setTaulaSpacialFilter={this.props.setTaulaSpacialFilter}
                      taulaSpacialFilter={this.props.taulaSpacialFilter}
                      setTaulaLayer={this.props.setTaulaLayer}
                      deleteTaula={this.props.deleteTaula}
                      changeLlegendaOpen={(isOpen) => this.props.changeLlegendaOpen(isOpen)}
                      taulaResp={this.props.taulaResp}
                      setTaulaResp={this.props.setTaulaResp}
                      setTaulaConditions={this.props.setTaulaConditions}
                      taulaConditions={this.props.taulaConditions}
                      taulaArray={this.props.taulaArray}
                      taulaLayer={this.props.taulaLayer}
                      taulaOpen={this.props.taulaOpen}
                      selectVector={this.props.selectVector}
                      taulaFilters={this.props.taulaFilters}
                      isSelecting={this.props.isSelecting}
                      resetSelected={this.props.resetSelected}
                      selectedArray={this.props.selectedArray}
                      selectedFeatures={this.props.selectedFeatures}
                      toggleSelecting={this.props.toggleSelecting}
                      setTaulaFilters={this.props.setTaulaFilters}
                      filterVector={this.props.filterVector}
                      filterSource={this.props.filterSource}
                      getTaulaArray={this.props.getTaulaArray}
                      scale={this.props.scale}
                      onStyleChangeOrder={() => this.onStyleChangeOrder()}
                      isDragging={layer.isDragging()}
                      expandAll={this.state.expandAll}
                      map={this.props.map}
                      id="CapaLlegenda"
                      key={index}
                      layer={layer}
                      arrayLayers={this.props.arrayLayers}
                      arrayExternalLayers={this.props.arrayExternalLayers}
                      llegendaObj={this.props.llegendaObj}
                      handleDeleteLayer={this.props.handleDeleteLayer}
                      handleArrayChange={this.props.handleLayerArrayChange}
                      handleEraseInfoCard={this.props.handleEraseInfoCard}
                      fontSizeEnabled={this.props.fontSizeEnabled}
                      toggleDrawing={this.props.toggleDrawing}
                      toggleAlert={this.props.toggleAlert}></CapaLlegenda>
                  );
                })}
              </CapesLlegendaWrapper>
              <LlegendaFooter
                map={this.props.map}
                arrayLayers={this.props.arrayLayers}
                arrayExternalLayers={this.props.arrayExternalLayers}
                fontSizeEnabled={this.props.fontSizeEnabled}
                filterVector={this.props.filterVector}
                deleteTaula={this.props.deleteTaula}
                onClickInfoPunt={this.props.onClickInfoPunt}
                handleEraseInfoCard={this.props.handleEraseInfoCard}
                handleDeleteLayer={this.props.handleDeleteLayer}
                shrinkAll={this.shrinkAll}
                expandAll={this.expandAll}></LlegendaFooter>
            </LlegendaMenuWrapper>
          </LlegendaWrapper>
        </LlegendaContainer>
      </>
    );
  };
}
